import React, { memo, useState } from 'react';
import parseHtmlString from 'html-react-parser';
import classNames from 'classnames';
import { ImmagineContenutoHtml } from '../../molecules/helpers-contenuto-html/ImmagineContenutoHtml';
import useWithMobileResizeListener from '../../utils/hooks/useWithMobileResizeListener';
import GenericModal from '../generic-modal/GenericModal';
import ButtonWithLink from '../../organisms/button/Button';
import ArrowRightCircle from '../../atoms/static-icons/arrow-right-circle';

const ContenutoHtmlInner = ({ rawContent = '', copyrightYear }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const isMobile = useWithMobileResizeListener(768);

  const handleClick = ({ src, alt }) => {
    setModalOpen(true);
    setImageSrc({ src, alt });
  };
  const renderHtmlContent = (htmlText) =>
    parseHtmlString(htmlText, {
      replace: (domNode) => {
        if (
          domNode?.attribs?.class === 'button-link-blog-primary' &&
          domNode?.children?.[0]?.data &&
          domNode?.attribs?.href
        ) {
          return (
            <ButtonWithLink
              text={domNode.children?.[0].data}
              type={'primary'}
              href={`${domNode.attribs.href}`}
            />
          );
        }
        if (
          domNode?.attribs?.class === 'button-link-blog-secondary' &&
          domNode?.children?.[0]?.data &&
          domNode?.attribs?.href
        ) {
          return (
            <ButtonWithLink
              text={domNode.children?.[0].data}
              type={'secondary'}
              href={`${domNode.attribs.href}`}
              order='icon-right'
              icon={ArrowRightCircle}
            />
          );
        }
        if (
          domNode?.attribs?.class === 'button-link-blog-tertiary' &&
          domNode?.children?.[0]?.data &&
          domNode?.attribs?.href
        ) {
          return (
            <ButtonWithLink
              text={domNode.children?.[0].data}
              type={'tertiary'}
              href={`${domNode.attribs.href}`}
            />
          );
        }
        if (!!copyrightYear && domNode.name === 'p') {
          return (
            <p>
              {copyrightYear}
              {htmlText?.replace('<p>', '')?.replace('</p>', '')}
            </p>
          );
        }
        if (domNode.name === 'div' && domNode.attribs.class === 'img-zoom') {
          const imageElement = domNode?.children?.find((childNode) => {
            return childNode?.name === 'img';
          });
          const alignCenter = imageElement?.attribs?.style?.includes(
            'margin-left: auto; margin-right: auto;'
          );
          return (
            imageElement &&
            imageElement?.attribs?.src && (
              <div
                className={classNames('zoom-image', {
                  'zoom-image--center': alignCenter,
                })}
              >
                <ImmagineContenutoHtml
                  isMobile={isMobile}
                  handleClick={handleClick}
                  imageElement={imageElement}
                />
              </div>
            )
          );
        }

        if (
          domNode.name === 'div' &&
          domNode.attribs.id &&
          domNode.children?.[0].data === String.fromCharCode(160)
        ) {
          return <div id={domNode.attribs.id}></div>;
        }
      },
    });
  return (
    <>
      {renderHtmlContent(rawContent)}
      {isModalOpen && (
        <GenericModal
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          className='box-editorial__modal'
        >
          <img src={imageSrc.src} alt={imageSrc.alt}></img>
        </GenericModal>
      )}
    </>
  );
};

export const ContenutoHtmlInnerMemo = memo(ContenutoHtmlInner);

export default ContenutoHtmlInner;
